<template>
  <div class="content-wrapper">
    <vs-row class="my-4">
      <vs-col vs-lg="8" vs-sm="12">
        <vs-button
          :to="`/videos/add` + suffixParams"
          color="primary"
          type="filled"
          >Add New</vs-button
        >
      </vs-col>
      <vs-col vs-lg="4" vs-sm="12">

        <div style="float: right">
          <vs-input
            id="search"
            class="inputx"
            placeholder="Search..."
            v-model="search"
            v-on:input="debounceInput"
          />
        </div>
      </vs-col>
    </vs-row>
    <vx-card>
      <b-table
        ref="table"
        style="min-height: 600px"
        striped
        hover
        fixed
        responsive
        show-empty
        sort-icon-left
        :selectable="true"
        :select-mode="`multi`"
        :busy.sync="isBusy"
        :items="dataProvider"
        :fields="columns"
        :current-page="currentPage"
        :per-page="perPage"
        :filter="filter"
        :filterIncludedFields="filterOn"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :sort-direction="sortDirection"
      >
        <template v-slot:table-busy>
          <div class="text-center text-danger my-2" style="height: 600px">
            <b-spinner class="align-middle"></b-spinner>
            <div class="mt-3">
              <strong>Loading...</strong>
            </div>
          </div>
        </template>
        <template v-slot:cell(status.publish_status)="data">
          <vs-switch
            v-if="data.item.status.publish_status != null"
            v-model="data.item.status.publish_status"
            icon-pack="feather"
            vs-icon="icon-check"
            @change="onStatusChanged(data.item)"
          />
        </template>

        <template v-slot:cell(status.listing_status)="data">
          <vs-switch
            v-if="data.item.status.listing_status != null"
            v-model="data.item.status.listing_status"
            icon-pack="feather"
            vs-icon="icon-check"
            @change="onStatusChanged(data.item)"
          />
        </template>

        <template v-slot:cell(status.featured_status)="data">
          <vs-switch
            v-if="data.item.status.featured_status != null"
            v-model="data.item.status.featured_status"
            icon-pack="feather"
            vs-icon="icon-star"
            @change="onStatusChanged(data.item)"
          />
        </template>

        <template v-slot:cell(quantity)="data">
          <div v-if="data.item.products[0].qty === null">
            Unlimited
          </div>
          <div v-else>
            {{ Number(data.item.products[0].qty) }}
          </div>
        </template>

        <template v-slot:cell(pro_name)="data">
          <div class="d-flex align-items-center">
            <img
              v-if="data.item.poster"
              style="width: 120px;"
              :src="data.item.poster"
              alt=""
            />
            <img
              v-else
              style="width: 120px;"
              src="https://assets.soldoutt.com/pttgc/poster/morningsession-poster-1658745423.jpg"
            />
            <span class="ml-4">{{ data.item.pro_name }}</span>
          </div>
        </template>
        <template v-slot:cell(date_text)="data">
          <div style="width:200px;">
            <span>{{ data.item.date_text }} {{ data.item.time_text }}</span>
          </div>
        </template>
        <!-- <template v-slot:cell(time_text)="data">
          <div style="width:130px;">
            <span>{{ data.item.time_text }}</span>
          </div>
        </template> -->

        <template v-slot:cell(action)="data">
          <div>
            <a
              :href="'/videos/' + data.item.video_id + '/view' + '' + suffixParams"
            >
              <i
                class="far fa-edit"
                style="font-size: 24px;"
              ></i
            ></a>
            <!-- <vs-button
              size="small"
              @click="open(data.item)"
              color="primary"
              type="flat"
              >Edit</vs-button
            > -->
            <!-- <vs-button
              class="ml-1"
              size="small"
              v-if="data.item.speaker_url_copy"
              @click.prevent="doCopy(data.item.speaker_url_copy)"
              color="primary"
              type="flat"
              >Copy Speaker URL</vs-button
            > -->
          </div>
        </template>
      </b-table>

      <div class="mt-3 text-center">
        <vs-pagination
          :total="Math.ceil(totalRows / 30)"
          v-model="currentPage"
          prev-icon="arrow_back"
          next-icon="arrow_forward"
        ></vs-pagination>

        <div class="mt-3">{{ from }} to {{ to }} of {{ totalRows }} items</div>
      </div>
    </vx-card>
  </div>
</template>
<script>
import { mapState } from "vuex";
import Service from "@/services";
import moment from "moment";

export default {
  components: {},
  data: () => ({
    suffixParams: "",
    columns: [
      { label: "ID", key: "video_id", sortable: false },
      // {
      //   label: "Featured Status",
      //   key: "status.featured_status",
      //   sortable: false
      // },
      {
        label: "Video",
        key: "pro_name",
        sortable: false
        // tdClass: "width-250"
      },
      {
        label: "Publish Status",
        key: "status.publish_status",
        sortable: false,
        tdClass: "width-125"
      },
      {
        label: "Listing Status",
        key: "status.listing_status",
        sortable: false,
        tdClass: "width-125"
      },
      // {
      //   label: "Stage",
      //   key: "stage",
      //   sortable: false,
      //   tdClass: ""
      // },
      // {
      //   label: "Quantity",
      //   key: "quantity",
      //   sortable: false,
      //   tdClass: ""
      // },
      // {
      //   label: "Date",
      //   key: "date_text",
      //   tdClass: "width-450",
      //   sortable: false
      // },
      { label: "", key: "action", tdClass: "width-125", sortable: false }
    ],
    lastSearch: "",
    search: "",
    filter: "",
    sortBy: "",
    sortDesc: false,
    sortDirection: "asc",
    from: 1,
    to: 0,
    isBusy: false,
    currentPage: 1,
    perPage: 30,
    totalRows: 0,
    selected: [],
    filterOn: [],
    pageOptions: [2, 5, 10, 15, 30, 50]
  }),
  watch: {
    currentPage: {
      handler: function(val, oldVal) {
        if (oldVal != val) {
        }
      }
    }
  },
  computed: {
    ...mapState({
      s: state => {
        return state.Utility.s;
      },
      e: state => {
        return state.Utility.e;
      }
    })
  },
  methods: {
    debounceInput: _.debounce(function(e) {
      this.lastSearch = this.search
      this.filter = e;
      this.search = e;
      if (this.lastSearch != this.search) {
        this.currentPage = 1
      }
    }, 500),
    onStatusChanged: _.debounce(function(e) {
      let data = {
        video_id: e.video_id,
        e: this.e,
        s: this.s,
        target: 'merchant',
        ...e.status
      };
      this.$vs.loading();
      Service.Video.update(e.video_id,data).then(res => {
        if (res.success) {
          this.$vs.notify({
            title: "Success",
            text: "Update complete.",
            color: "success"
          });
        }

        this.$vs.loading.close();
      });
    }, 500),
    dataProvider(ctx, callback) {
      this.isBusy = true;
      setTimeout(() => {
        this.isBusy = true;

        let data = {
          event_type: "video",
          e: this.e,
          s: this.s,
          target: 'merchant',
          search: this.search,
        };

        let params = Object.keys(data)
          .map(key => key + "=" + data[key])
          .join("&");

        params =
          params +
          "&" +
          Object.keys(ctx)
            .map(key => key + "=" + ctx[key])
            .join("&");

        Service.Video.gets(params)
          .then(res => {
            this.isBusy = false;
            this.totalRows = res.data.total;
            this.from = res.data.from;
            this.to = res.data.to;
            console.log(res.data)

            this.data = res.data.rows.map(item => {
              // let stage = item.venue;
              let pro_name = item.pro_name;
              let poster = item.poster;
              let status = {
                publish_status: !!item.publish_status,
                listing_status: !!item.listing_status
              };
              // let speaker_url_copy = null;

              // if (item.live_event.length > 0) {
              //   status.publish_status = item.live_event[0].publish_status;
              //   status.listing_status = item.live_event[0].listing_status;
              //   status.featured_status = item.live_event[0].featured_status;
              //   speaker_url_copy =
              //     "https://" +
              //     item.live_event[0].domain +
              //     "/" +
              //     item.slug +
              //     "/speaker";
              // }
              return {
                ...item,
                // stage: stage,
                pro_name: pro_name,
                poster: poster,
                date_text: moment(item.datetime, "YYYY-MM-DD HH:mm").format(
                  "DD MMM YYYY"
                ),
                // time_text:
                //   moment(item.datetime, "YYYY-MM-DD HH:mm").format("HH:mm") +
                //   " - " +
                //   moment(item.datetime_end, "YYYY-MM-DD HH:mm").format("HH:mm"),
                status: status,
                // speaker_url_copy: speaker_url_copy
              };
            });

            callback(this.data);
          })
          .catch(error => {
            console.log(error)
            // Here we could override the busy state, setting isBusy to false
            // this.isBusy = false
            // Returning an empty array, allows table to correctly handle
            // internal busy state in case of error
            //return [];
            callback([]);
          });
        return null;
      }, 500);
    },
    open(item) {
      this.$router.push(
        "/videos/" + item.slug + "/view" + "" + this.suffixParams
      );
    },
    doCopy(text) {
      this.$copyText(text).then(
        e => {
          this.$vs.notify({
            title: "Success",
            text: "Copied",
            color: "success"
          });
        },
        e => {
          this.$vs.notify({
            title: "Oops!",
            text: "Can not copy",
            color: "danger"
          });
        }
      );
    }
  },
  mounted() {
    this.suffixParams =
      "?s=" + this.$route.query.s + "&e=" + this.$route.query.e;
  }
};
</script>
